import ThemePadding from "containers/admin/clients/client/theme-page/preview/components/theme-padding/theme-padding";
import { FieldLabel } from "ui/forms";

const ContentPadding = ({ sectionName }: { sectionName: string }) => {
  return (
    <div>
      <FieldLabel name={sectionName}>Padding (px)</FieldLabel>

      <div className="mt-2">
        <ThemePadding
          formFieldPrefix={`${sectionName}.mobile`}
          label="Mobile"
          customClassLabel="font-normal"
        />
      </div>

      <div className="mt-2">
        <ThemePadding
          formFieldPrefix={`${sectionName}.desktop`}
          label="Desktop"
          customClassLabel="font-normal"
        />
      </div>
    </div>
  );
};

export default ContentPadding;
